import React from 'react';
import BrandBadge from '../BrandBadge';

// The frame both sign-in screens sit in, matching the phone app: a soft
// gradient page, a frosted card that breathes, and the brand mark floating
// above the form. Only the subtitle and the form itself differ between them.
const AuthShell = ({ subtitle, children }) => (
  <div
    className="relative flex min-h-screen w-full items-center justify-center p-4"
    style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}
  >
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage:
          'radial-gradient(circle at 20% 80%, rgba(70, 110, 195, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(33, 57, 102, 0.05) 0%, transparent 50%)',
      }}
    />

    <div className="relative z-10 w-full max-w-[480px] overflow-hidden rounded-3xl border border-primary-900/10 bg-white/95 p-8 backdrop-blur-[20px] animate-glow min-[600px]:p-12">
      {/* A thin light bar crossing the top edge of the card. */}
      <div className="absolute left-0 top-0 h-0.5 w-full bg-gradient-to-r from-transparent via-primary-600 to-transparent animate-sweep" />

      <div className="mb-8 flex justify-center animate-float">
        <BrandBadge />
      </div>

      <div className="mb-10 text-center">
        <h1 className="mb-2 bg-gradient-to-br from-primary-900 to-primary-600 bg-clip-text text-3xl font-bold text-transparent">
          Welcome Back
        </h1>
        <p className="text-base text-gray-600">{subtitle}</p>
      </div>

      {children}
    </div>
  </div>
);

export default AuthShell;
